import "./TextArea.scss";

export function TextArea({ ...rest }) {
  return <textarea {...rest} className="textarea" />;
}
